var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select_code"},[_c('bm_select_code',{on:{"choose":function($event){return _vm.selectCountry($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }